var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import { useQuery } from 'react-query';
export var AsyncResourceContext = createContext({});
export var createAsyncResource = function () {
    return function (_a) {
        var queryOptions = _a.queryOptions, children = _a.children;
        var query = useQuery(queryOptions);
        if (!query.data)
            return null;
        return (_jsx(AsyncResourceContext.Provider, __assign({ value: query.data }, { children: children })));
    };
};
